import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../_service/authentication.service';

import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: 'forgot.component.html',
    styleUrls: ['forgot.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ForgotComponent implements OnInit {
    model: any = {};
    loading = false;
    error = '';
    errorMsg = '';
    sent = false;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        translate: TranslateService) {
        translate.get('forgot.error').subscribe((res: string) => {
            this.errorMsg = res;
        });
    }

    ngOnInit() {
        // reset login status
        this.authenticationService.logout();
    }

    forgot() {
        this.loading = true;
        this.authenticationService.forgot(this.model.email)
            .subscribe(result => {
                if (result === true) {
                    this.sent = true;
                    this.loading = false;
                } else {
                    this.error = this.errorMsg;
                    this.loading = false;
                }
            }, error => {
                this.error = this.errorMsg;
                this.loading = false;
            });
    }
}
